import { AddressParts } from './PlaceAutocomplete.types'

export function parseAddressComponents(
  components: google.maps.GeocoderAddressComponent[] | undefined,
): AddressParts | null {
  if (!components) return null

  const get = (type: string) => components.find((c) => c.types.includes(type))

  const streetNumber = get('street_number')?.long_name
  const route = get('route')?.long_name
  const locality = get('locality')?.long_name
  const postalTown = get('postal_town')?.long_name
  const state = get('administrative_area_level_1')?.long_name
  const stateCode = get('administrative_area_level_1')?.short_name
  const country = get('country')?.long_name
  const countryCode = get('country')?.short_name
  const postalCode = get('postal_code')?.long_name

  const city = locality || postalTown
  const streetAddress = [streetNumber, route].filter(Boolean).join(' ')

  return {
    streetNumber,
    route,
    streetAddress,
    city,
    state,
    stateCode,
    country,
    countryCode,
    postalCode,
  }
}
